// extracted by mini-css-extract-plugin
export default {"dropzone":"Uploader_dropzone__laOe6","active":"Uploader_active__vHq6I"};